import template         from "./codemirror-withsyntaxhighlight.html";
import css              from "./codemirror-withsyntaxhighlight.css";

import CodeMirror       from "codemirror";
import mode_javascript  from "/lib/codemirror/mode/javascript/javascript.js";
import {Icon}           from "gui";
import * as Acorn       from "acorn";
import JSHINT           from "jshint";
import stage3           from "acorn-stage3";

class MyCodeMirror extends CodeMirror {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static get schema() {
    return({
      "description": "CodeMirror with Syntax Highlight",
      "type": "object",
      "properties": {}
    });
  }
  static get designer() {
    return({
      "category": "User Defined",
      "icon": {"context": "actions", "size": 16, "iconname": "insert-button"}
    });
  }  
  static constructor() {
    //Acorn.Parser.extend(stage3);
    customElements.define("biocore-codemirror-withsyntaxhighlight", MyCodeMirror);
  }
  constructor(p={}) {
    p.gutters = ["CodeMirror-linenumbers", "errors"];
    super(p);

    this.on("change", this.__parse.bind(this));
  }
  set value(value) {
    this.setValue(value);
  }
  get value() {
    return this.getValue();
  }
  __parse() {
    this.clearGutter("errors");

    JSHINT(this.getValue(), {
      esversion: 11,
      undef: true,
      unused: true,
      browser: true,
      devel: true,
      module: false,
      predef: ["devices", "h", "T", "pH", "pO2", "STR", "GSFL", "log", "logData", "stop", "settings", "target_pO2", "target_T", "target_pH"]
    });

    for (var i = 0; i < JSHINT.errors.length; ++i) {
      var e = JSHINT.errors[i];
      if (!e) continue;
      this.setGutterMarker(e.line-1, "errors", new Icon({
        size: 16,
        context: "status",
        iconname: "dialog-warning",
        title: e.reason
      }) );
    }

    try {
      Acorn.parse(this.getValue(), {
        ecmaVersion: "latest",
        sourceType: "module"
      });
    } catch(e) {
      this.setGutterMarker(e.loc.line-1, "errors", new Icon({
        size: 16,
        context: "emblems",
        iconname: "emblem-important",
        title: e.message
      }) );
    }
  }
}

MyCodeMirror.constructor();

export default MyCodeMirror;